import { useState } from "react";
// import { Modal, Spinner } from "react-bootstrap";
// import Cropper from "react-easy-crop";
import uploadPic from "shared/assets/images/png/upload.png";
// import RotateLeft from "assets/images/svg/rotate_left.svg";
// import RotateRight from "assets/images/svg/rotate_right.svg";
// import zoom_in from "shared/assets/images/svg/zoom_in.svg";
// import zoom_out from "shared/assets/images/svg/zoom_out.svg";
// import { getCroppedImg } from "shared/helpers/canvas";
// import { client, fileURL } from "shared/helpers/client";
// import {toast} from "react-toastify";
// import {useTranslation} from "react-i18next";


const FileUploader = ({ name, label,initialImage,binaryImg=false, modalTitle, onFileSubmit, error , readOnly }) => {
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileLoaded = (file) => {
    setFile(file);
    setShow(true);
    onFileSubmit(file)
  };

  return (
    <div>
      <div>
        <FileInput
          file={file}
          name={name}
          label={label}
          onFileLoaded={handleFileLoaded}
          error={error}
          readOnly={readOnly}
          initialImage={initialImage}
          binaryImg={binaryImg}
        />
      </div>
    </div>
  );
};

const FileInput = ({ label,file,initialImage,binaryImg, name, onFileLoaded, error, readOnly }) => {
  if (readOnly) {
    return (
      <>
        <div className="input-file">
          <label htmlFor={name} >
            <div>
              
            <img src={ file ? URL.createObjectURL(file)  : initialImage ? initialImage : uploadPic} alt="upload_image" />
            </div>
            <span> {label} </span>
          </label>
        </div>
      </>
    );
  }
  return (
    <div className={error ? "error" : ""}>
        <label htmlFor={name} className="img-upload">
          <div>
          
          <img src={ file ?  URL.createObjectURL(file) : initialImage ? binaryImg ? `data:image/*;base64,${initialImage}`: initialImage : uploadPic} alt="upload_image" />
          </div>
          <input
            id={name}
            type="file"
            accept="image/*"
            className="d-none"
            onClick={(event) => (event.target.value = null)}
            onChange={(e) => onFileLoaded(e.target.files[0])}
          />
          <span> {label} </span>
        </label>
      <p className="textError">{typeof error === "object" ? error.message : error}</p>
    </div>
  );
};



export default FileUploader;
